module.exports = __webpack_public_path__ + "img/073423.df023dc4.png";